import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import Orders from './pages/Orders';
import Products from './pages/Products';
import Followup from './pages/Followup';
import LiveSession from './pages/LiveSession';
import Settings from './pages/Settings';
import PostLive from './pages/PostLive';
import BillPrint from './pages/BillPrint';
import BillingQueue from './pages/BillingQueue';
import Bills from './pages/Bills';
import Shipments from './pages/Shipments';
import Stock from './pages/Stock';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ color: '#6c757d', padding: 40 }}>Loading...</div>;
  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="customers" element={<Customers />} />
        <Route path="orders" element={<Orders />} />
        <Route path="products" element={<Products />} />
        <Route path="followup" element={<Followup />} />
        <Route path="live" element={<LiveSession />} />
        <Route path="settings" element={<Settings />} />
        <Route path="postlive" element={<PostLive />} />
        <Route path="billprint" element={<BillPrint />} />
        <Route path="billing" element={<BillingQueue />} />
        <Route path="bills" element={<Bills />} />
        <Route path="shipments" element={<Shipments />} />
        <Route path="stock" element={<Stock />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" toastOptions={{
          style: { background: '#ffffff', color: '#212529', border: '1px solid #dee2e6', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }
        }} />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}